const avatarInitials = name => name.split(" ").map(item => item[0]).join("");

export default avatarInitials;
